const dropShadow = {
  sm: 'filter: drop-shadow(0 0px 2px rgb(0 0 28 / 0.20)) backdrop-filter: blur(5px)',
  md: 'filter: drop-shadow(0 0px 5px rgb(0 0 28 / 0.30)) backdrop-filter: blur(10px)',
  lg: 'filter: drop-shadow(0 0px 10px rgb(0 0 28 / 0.20)) backdrop-filter: blur(20px)',
};

export default dropShadow;
